import { axiosPrivate } from 'app/utils';

import helpers from './helpers';

export default {
  async getClinicMessages({ clinicId, status }) {
    const resourceLink = helpers.getResourceLink(`/v3/clinics/${clinicId}/messages`, { status });

    const response = await axiosPrivate.get(resourceLink);
    return response.data;
  },

  async getClinicMessageStats({ clinicId }) {
    const resourceLink = helpers.getResourceLink(`/v3/clinics/${clinicId}/message-stats`);

    const response = await axiosPrivate.get(resourceLink);
    return response.data;
  },
};
